import { cva } from 'class-variance-authority';

export const containerStyles = cva(['flex', 'flex-col', 'md:flex-row', 'gap-10', '!py-5']);

export const titleStyles = cva(['font-bold', 'text-gray-900', 'md:text-display-md', 'text-display-sm-mobile']);

export const speakerCardStyles = cva([
  'relative',
  'flex',
  'w-full',
  'overflow-hidden',
  'px-5',
  'py-4',
  'min-h-[115px]',
  'shadow-sm',
  'lg:max-w-[calc(50%-20px)]',
  ' xl:h-[110px]',
]);

export const headshotStyles = cva(['h-[80px]', 'w-[80px]', 'min-w-[80px]', 'mr-5', 'rounded-full', 'object-cover']);
